
import { 
    ADD_CASE,
    ADD_CASE_SUCCESS,
    ADD_CASE_FAIL, 
    ADD_CASE_RESET,
} from "../actions/addCaseAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const addCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CASE:
            return {
                ...state,
                apiState: "loading",
            };
        case ADD_CASE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case ADD_CASE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case ADD_CASE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default addCaseReducer;
